<template>
  <ExternalQueryList
      endpoint="/api/v2/invoices"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => false"
      :can-update="() => true"
      @show="invoice => $router.push(getUrl(invoice))"
  >
    <template v-slot:default="{ row: invoice }">
      <td>
        <router-link :to="getUrl(invoice)">
          {{ invoice.id }}
        </router-link>
      </td>

      <td>
        {{ invoice.attributes.headline }}
      </td>

      <td class="table__ellipsis">
        {{ invoice.attributes.recipient_name }}
      </td>

      <td>
        {{ invoice.attributes.recipient_customer_accounting_number }}
      </td>

      <td>
        {{ invoice.attributes.created_at | date }}
      </td>

      <td>
        {{ invoice.attributes.price | price }}
      </td>

      <td>
        <StatusLabel :status="invoice.attributes.status"/>&nbsp;<StatusLabel :status="invoice.attributes.accounting_system_status" v-if="invoice.attributes.accounting_system_status === 'drafted'"/>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import StatusLabel from "../../../StatusLabel.vue";

export default {
  components: {StatusLabel, ExternalQueryList},

  computed: {
    headlines() {
      return [
        {width: 2, text: 'ID'},
        {width: 6, text: 'Headline'},
        {width: 4, text: 'Recipient'},
        {width: 3, text: 'Customer'},
        {width: 2, text: 'Date'},
        {width: 2, text: 'Price'},
        {width: 3, text: 'Status'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 8,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 3,
            widget: 'date',
            name: 'created_from',
            placeholder: '(created from...)'
          },
          {
            width: 3,
            widget: 'date',
            name: 'created_to',
            placeholder: '(created to...)',
          },
          {
            width: 3,
            widget: 'select',
            name: 'status',
            placeholder: '(all statuses...)',
            nullable: true,
            options:[
              {value: 'credited', label: 'Credited'},
              {value: 'paid', label: 'Paid'},
              {value: 'third-notice', label: 'Third Notice'},
              {value: 'second-notice', label: 'Second Notice'},
              {value: 'first-notice', label: 'First Notice'},
              {value: 'overdue', label: 'Overdue'},
              {value: 'unpaid', label: 'Unpaid'},
              {value: 'failed', label: 'Failed'},
            ]
          },
          {
            width: 3,
            widget: 'select',
            name: 'accounting_system_status',
            placeholder: '(all accounting system statuses...)',
            nullable: true,
            options:[
              {value: 'empty', label: 'Empty'},
              {value: 'drafted', label: 'Drafted'},
              {value: 'booked', label: 'Booked'}
            ]
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(invoice) {
      return '/' + invoice.attributes.recipient_type + '/' + invoice.attributes.recipient_id + '/invoices/' + invoice.id
    }
  }
}
</script>
